import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PilotFaqV2 from "../pilot-faq-v2";

const ScrapCarsFaq = ({
    faqList = [], faqTitle = ""
}) => {
    if (!faqList.length) return null;
    return (
        <div styleName={"styles.faqMainWrapper"}>
            <PilotFaqV2 heading={faqTitle} list={faqList} transparent dividerHeading={true} />
        </div>
    );
};

ScrapCarsFaq.propTypes = {
    faqList: PropTypes.array,
    faqTitle: PropTypes.string
};

export default ScrapCarsFaq;
